<div class="row space-between center" ngClass.xs="justify-flex-end">
  <div class="searchbox" style="width: 250px" ngClass.xs="display-none">
    <mat-icon svgIcon="search"></mat-icon>
    <input type="text" placeholder="Search" [value]="filterValues['global'] || ''" (keyup.enter)="$event.target.blur()" (input)="tt.filterGlobal($event.target.value, 'contains')">
  </div>

  <!-- For mobile only - Display if active filters on table -->
  @if (getObjLength(columnFilters)) {
    <div ngClass.xs="display-block" class="filters-active display-none">
      {{getObjLength(columnFilters)}} Filter{{getObjLength(columnFilters) === 1 ? '' : 's'}} Active
    </div>
  }

  @if (canEdit) {
    <button mat-mini-fab (click)="openCreateModal()" matTooltip="Create" class="create-button">
      <mat-icon svgIcon="add"></mat-icon>
    </button>
  }
</div>
<div>
  <p-table #tt dataKey="id" [columns]="columns" [alwaysShowPaginator]="true" [value]="storageBoxes" styleClass="clickable shadow" [rows]="rowsPerPage" [(rows)]="rowsPerPage" [paginator]="true"
    [rowsPerPageOptions]="rowsPerPageOptions" (sortFunction)="onSort($event)" [customSort]="true" (onFilter)="onTableFilter($event)"
    responsiveLayout="scroll">
    <!-- Summary -->
    <ng-template pTemplate="summary" styleClass=".ptable-summary">
      @if (isLoading) {
        <div>
          <span>
            Loading...
          </span>
        </div>
      }
      @if (!isLoading && (tt.filteredValue && tt.filteredValue.length === 0) && storageBoxes.length !== 0) {
        <div>
          <span>
            There are no {{storageBoxField.name}}(s) to display. Adjust your filters for more results.
          </span>
        </div>
      }
      @if (!isLoading && storageBoxes.length === 0) {
        <div>
          <span>
            This warehouse contains no {{storageBoxField.name}}(s).
          </span>
        </div>
      }
    </ng-template>
    <!-- Headers -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track $index) {
          <th [pSortableColumn]="col.canonical_name">
            {{col.name}}
            <p-sortIcon [field]="col.canonical_name"></p-sortIcon>
            <!-- Column Filters -->
            <div>
              @switch (col.canonical_name) {
                <!-- Warehouse Location -->
                @case ('warehouse_location_id') {
                  <p-multiSelect placeholder="Search" #multiSelectRef appendTo="body" [options]="warehouseLocationOptions" defaultLabel="Search"
                    (onChange)="onColumnFilter($event?.value, col)" (click)="$event.stopPropagation();" [styleClass]="(columnFilters && columnFilters[col.canonical_name]) ? 'p-column-filter active-filter' : 'p-column-filter'" [autofocusFilter]="true"
                  [ngModel]="(columnFilters && columnFilters[col.canonical_name]) ? columnFilters[col.canonical_name].value : []" [virtualScroll]="true" [virtualScrollItemSize]="30" >
                  <ng-template pTemplate="header">
                    <div class="custom-multiselect-header">
                        <button
                            type="button"
                            class="close-button"
                            (click)="multiSelectRef.hide()"
                            aria-label="Close"
                        >
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </ng-template>
                </p-multiSelect>
                }
                <!-- Warehouse Sub Location -->
                @case ('warehouse_sub_location_id') {
                  <p-multiSelect placeholder="Search" #multiSelectRef appendTo="body" [options]="warehouseSubLocationOptions" defaultLabel="Search"
                    (onChange)="onColumnFilter($event?.value, col)" (click)="$event.stopPropagation();" [styleClass]="(columnFilters && columnFilters[col.canonical_name]) ? 'p-column-filter active-filter' : 'p-column-filter'" [autofocusFilter]="true"
                  [ngModel]="(columnFilters && columnFilters[col.canonical_name]) ? columnFilters[col.canonical_name].value : []" [virtualScroll]="true" [virtualScrollItemSize]="30">
                  <ng-template pTemplate="header">
                    <div class="custom-multiselect-header">
                        <button
                            type="button"
                            class="close-button"
                            (click)="multiSelectRef.hide()"
                            aria-label="Close"
                        >
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </ng-template>
                </p-multiSelect>
                }
                <!-- Space -->
                @case ('space') {
                  <p-select appendTo="body" [options]="spaceOptions" defaultLabel="Search" (onChange)="onColumnFilter($event?.value, col)"
                    (click)="$event.stopPropagation();" [styleClass]="(columnFilters && columnFilters[col.canonical_name]) ? 'p-column-filter active-filter' : 'p-column-filter'"
                  [ngModel]="(columnFilters && columnFilters[col.canonical_name]) ? columnFilters[col.canonical_name].value : []" [virtualScroll]="true" [virtualScrollItemSize]="30"></p-select>
                }
                <!-- Default -->
                @default {
                  <input pInputText type="text" placeholder="Search" [value]="filterValues[col.canonical_name] || null" class="p-column-filter"
                    (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation()" (keyup)="onColumnFilter($event?.target.value, col)" [class.active-filter]="columnFilters && columnFilters[col.canonical_name]">
                }
              }
            </div>
          </th>
        }
        <!-- Empty Column Name for Delete -->
        @if (canEdit) {
          <th style="width: 60px" ngClass.xs="display-none"></th>
        }
      </tr>
    </ng-template>
    <!-- Body -->
    <ng-template pTemplate="body" let-storageBox let-columns="columns">
      <tr class="clickable mobile-data-row" (click)="onRowClick($event, storageBox)">
        @for (col of columns; track $index) {
          <td class="mobile-data">
            <!-- Header on Mobile -->
            <span class="p-column-title">{{col.canonical_name!=='barcode'?col.name:''}}</span>
            <span class="mobile-data-cell">
              @switch (col.canonical_name) {
                @case ('warehouse_location_id') {
                  <span>
                    {{ warehouseLocationEnts[storageBox[col.canonical_name]] ? warehouseLocationEnts[storageBox[col.canonical_name]].name : ''
                    }}
                  </span>
                }
                @case ('warehouse_sub_location_id') {
                  <span>
                    {{ warehouseSubLocationEnts[storageBox[col.canonical_name]] ? warehouseSubLocationEnts[storageBox[col.canonical_name]].name
                    : '' }}
                  </span>
                }
                @case ('space') {
                  <span>
                    @if (storageBox[col.canonical_name] === true) {
                      <mat-icon svgIcon="check"></mat-icon>
                    }
                  </span>
                }
                @default {
                  <span>
                    {{storageBox[col.canonical_name]}}
                  </span>
                }
              }
            </span>
          </td>
        }
        @if (canEdit) {
          <td>
            <mat-icon class="clickable mobile-trash-icon" (click)="onDelete($event, storageBox)" svgIcon="delete"></mat-icon>
          </td>
        }
      </tr>
    </ng-template>
    <!-- Paginator -->
    <ng-template pTemplate="paginatorleft">
      <div ngClass.xs="display-none"><span> Results Per Page </span></div>
    </ng-template>
    <ng-template pTemplate="paginatorright" let-state>
      <span ngClass.xs="display-none">Total Results: {{state.totalRecords}}</span>
      <span ngClass.gt-xs="display-none">Total: {{state.totalRecords}}</span>
    </ng-template>
  </p-table>
</div>
